import * as React from 'react';
// import { useSelector } from "react-redux";
import ProductDetailRightContent from "./ProductDetail/ProductDetailRightContent/ProductDetailRightContent";
import { useProductStore } from 'src/hooks/product';

export function ProductDetailBuyBoxSeparatedComponent() {
    // const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    const [{ productDetail }] = useProductStore();
    return (
        <>
            <div className="logged-screen" style={{ display: productDetail?.value?.ItemNumber && !productDetail.ItemNumber ? '' : 'none' }}>
                <div className="content-area compare-open">
                    <div className="container">
                        <div className="bs5 row">
                            <div className="col-12">
                                <ProductDetailRightContent />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
